import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import ListIcon from "@mui/icons-material/List";
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

import {setLookViewType} from "../../../../actions/lookFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const LookViewTypeSwitcher = (props) => {

  const {intl, lookExpanded, lookViewType, setLookViewType, isMobile} = props;

  const listButtonClick = () => {
    const newViewType = lookViewType === 4 ? 1 : lookViewType + 1;
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMenuHeaderViewType + newViewType);
    setLookViewType(newViewType);
  };

  // lookViewType is now updated dynamically. check checkIfNeedToUpdateViewType func

  const getViewIcon = () => {
    switch (lookViewType) {
      case 1:
      default:
        return <ListIcon style={{ fontSize: 30 }}/>
      case 2:
        return <ViewStreamIcon style={{ transform: "rotate(90deg)" }}/>
      case 3:
        return <ViewStreamIcon/>
      case 4:
        return <ViewModuleIcon/>
    }
  }

  return (
    <IconButton aria-label={intl.formatMessage({id:"iconButton.list"})}
                disabled={lookExpanded}
                className={"look-icon look-icon--small" + (isMobile ? "" : " look-icon--white")}
                onClick={listButtonClick}>
      {getViewIcon(lookViewType)}
    </IconButton>
  )
};

const mapStateToProps = (store) => {
  const {lookExpanded, lookViewType} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookExpanded,
    lookViewType,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookViewType
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookViewTypeSwitcher)
)
